import { IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Center } from 'native-base';
import React from 'react';

interface StructuredOperationDetailsErrorPros {
  onClose: () => void;
}

export const StructuredOperationDetailsError: React.FC<StructuredOperationDetailsErrorPros> = ({
  onClose,
}) => (
  <VStack
    p={Spacing['inline.xxs']}
    bg={Color['neutral.white']}
    w={{ base: 'full', lg: '909px' }}
    borderRadius={'8px'}>
    <HStack w={'100%'} justifyContent={'flex-end'}>
      <IconButton
        onPress={onClose}
        testId={'icon-close'}
        icon="Close"
        iconSize={'xxxxs'}
        borderWidth={{ base: 0, lg: '1px' }}
        variant="rounded"
        backgroundColor="transparent"
        iconColor={Color['brand.primary.principal']}
        borderColor={Color['brand.primary.principal']}
      />
    </HStack>

    <Center py={'160px'}>
      <Text variant="bold" fontSize={Typography['fontsize.md']} color={'neutral.black'}>
        Erro ao carregar informações
      </Text>
      <Text
        textAlign={'center'}
        color={'neutral.black'}
        variant="regular"
        fontSize={Typography['fontsize.md']}>
        Ocorreu um erro ao carregar os detalhes desta operação.{'\n'}Por favor, tente novamente mais
        tarde ou verifique sua conexão com a internet.
      </Text>
    </Center>
  </VStack>
);
